module.exports = __webpack_public_path__ + "img/ship-access.28a0d101.png";